import { api } from '@/api/client';

export interface CompanyCheckRequest {
  country_id: string;
  company_identifier: string;
}

export interface CompanyCheckResponse {
  status: string;
  company_id?: string;
  company_name?: string;
}

export interface CreateJoinRequestRequest {
  companyUid: string;
  countryId: string;
}

export async function checkCompany(data: CompanyCheckRequest): Promise<CompanyCheckResponse> {
  return api.post<CompanyCheckResponse>('/v1/company/check', data);
}

export async function createJoinRequest(data: CreateJoinRequestRequest): Promise<void> {
  await api.post('/v1/create-join-request', data);
}
